module.exports = __webpack_public_path__ + "media/bootstrap-icons/wifi-1-3b25c498.svg";